import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";

import App from "./App";
import { Store } from "./redux/Store";

if (process.env.NODE_ENV === 'development') {
  const origError = console.error;
  console.error = (...args) => {
    if (args.some(arg => 
      typeof arg === 'string' && 
      arg.includes('ResizeObserver loop completed with undelivered notifications')
    )) {
      return;
    }
    origError(...args);
  };
}

// 2. Handle uncaught errors
const isResizeObserverError = (message?: string): boolean =>
  !!message &&
  (message.includes("ResizeObserver loop completed with undelivered notifications") ||
    message.includes("ResizeObserver loop limit exceeded"));

// Hides the CRA dev error overlay if the (benign) ResizeObserver loop error
// still bubbles up to react-error-overlay.
const hideDevOverlay = () => {
  ["react-error-overlay", "webpack-dev-server-client-overlay", "webpack-dev-server-client-overlay-div"]
    .forEach((id) => {
      const el = document.getElementById(id);
      if (el) el.style.display = "none";
    });
};

window.addEventListener(
  "error",
  (event) => {
    if (isResizeObserverError(event.message)) {
      event.stopImmediatePropagation();
      event.preventDefault();
      hideDevOverlay();
      setTimeout(hideDevOverlay, 0);
      return false;
    }
  },
  true
);

ReactDOM.render(
  <Provider store={Store}>
    <App />
  </Provider>,
  document.getElementById("root")
);